import Vue from 'vue';
import Vuex from 'vuex';

import main from './module-main';
import {eventBus} from "@store/module-main/eventBus";
import {_CONST} from "@/constants/constants";

export interface StateInterface {
  main: unknown;
}

Vue.use(Vuex);

const Store = new Vuex.Store<StateInterface | any>({
  modules: {
    main,
  },

  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
      reconnectCount: 0,
    },
  },

  mutations: {
    SOCKET_ONOPEN (state, event)  {
      if (event.target) Vue.prototype.$socket = event.currentTarget
      state.socket.isConnected = true;
      state.socket.reconnectCount = 0;
    },
    SOCKET_ONCLOSE (state, event)  {
      state.socket.isConnected = false;
      state.socket.reconnectCount = 0;
    },
    SOCKET_ONERROR (state, event)  {
      console.error(state, event)
    },
    SOCKET_ONMESSAGE (state, message)  {
      state.socket.message = message
    },
    SOCKET_RECONNECT(state, count) {
      console.info(state, count)
      state.socket.reconnectCount = count;
    },
    SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
      eventBus.$emit(_CONST.event.logout, {withRedirect: true})
    },
  },

  strict: !!process.env.DEV
});

export default Store
